import React from 'react';
import PropTypes from 'prop-types';
import GoogleMapView from './GoogleMapView';
class Location extends React.Component {   

    constructor(props){
        super(props);
    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    render(){

        console.log('LOCATION', this.props);
        return (
            <div className="Location">
                <p className="f5 m-0 bold c-primary">{this.props.location.name}</p>
                <p className="f5 m-0">Street Address: {this.props.location.address}</p>
                <p className="f5">Post Code: {this.props.location.postcode}</p>
                
                <div style={{maxWidth:200}}>
                <GoogleMapView zoom={14} location={this.props.geo} />
                <br/>
                </div>
                
            </div>
        )
    }
}

Location.propTypes = {
    
}

export default Location;


// WEBPACK FOOTER //
// ./src/components/common/Location.js